<template>
  <div class="big">
    <div class="page_title flex between">
      <span>统计详情</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container big">
        <div class="searchbox">
          <div class="item">
            <span class="searchtitle">回访人员</span>
            <el-select
              v-model="visit_id"
              placeholder="请选择"
              class="inputclass"
              clearable
              @change="search"
            >
              <el-option label="全部" :value="''"></el-option>
              <el-option
                v-for="item in nameList"
                :key="item.visit_id"
                :label="item.visit_name"
                :value="item.visit_id"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>
              <span class="searchtitle">回访总量：</span>
              <span>{{ visit_info.total_num }}</span>
            </span>
            <span style="margin: 0 40px">
              <span class="searchtitle">回访医生数：</span>
              <span>{{ visit_info.doctor_num }}</span>
            </span>
            <span>
              <span class="searchtitle">回访患者数：</span>
              <span>{{ visit_info.patient_num }}</span>
            </span>
            <span style="margin: 0 40px">
              <span class="searchtitle">回访处方数：</span>
              <span>{{ visit_info.pre_num }}</span>
            </span>
            <span>
              <span class="searchtitle">回访咨询数：</span>
              <span>{{ visit_info.consult_num }}</span>
            </span>
          </div>
        </div>
        <div class="searchbox">
          <div class="item">
            <span class="searchtitle">回访时间</span>
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="~"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="search"
              clearable
              style="width: 225px"
            ></el-date-picker>
          </div>
          <div class="item">
            <span class="searchtitle">回访类型</span>
            <el-select
              v-model="return_type"
              placeholder="请选择"
              class="inputclass"
              clearable
              @change="search"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="医生" :value="1"></el-option>
              <el-option label="患者" :value="2"></el-option>
              <el-option label="处方" :value="3"></el-option>
              <el-option label="咨询" :value="4"></el-option>
              <el-option label="其他" :value="5"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="searchtitle">回访来源</span>
            <el-select
              v-model="return_from"
              placeholder="请选择"
              class="inputclass"
              clearable
              @change="search"
            >
              <el-option label="全部" :value="0"></el-option>
              <el-option label="主动" :value="1"></el-option>
              <el-option label="被动" :value="2"></el-option>
            </el-select>
          </div>

          <div class="item">
            <span class="searchtitle">处理问题类型</span>
            <el-select
              v-model="solving_type"
              placeholder="请选择"
              class="inputclass"
              clearable
              @change="search"
            >
              <el-option label="全部" :value="''"></el-option>
              <el-option
                v-for="item in problemList"
                :key="item.problem_type"
                :label="item.problem_type"
                :value="item.problem_type"
              ></el-option>
            </el-select>
          </div>

          <div class="item">
            <span class="searchtitle">回访结果</span>
            <el-input v-model="treatment_method" clearable="" placeholder="请输入"></el-input>
          </div>
          <!-- <div class="item">
            <span class="searchtitle"
                  style="width:120px">是否需要继续回访</span>
            <span>
              <el-radio-group v-model="is_on_return"
                              @change="search">
                <el-radio :label="''">全部</el-radio>
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </span>
          </div> -->
          <div class="item">
            <span class="searchtitle">回访方式</span>
            <span>
              <el-radio-group v-model="visit_type" @change="search">
                <el-radio :label="''">全部</el-radio>
                <el-radio
                  :label="item.method"
                  v-for="(item, index) in methodList"
                  :key="index"
                  >{{ item.method }}</el-radio
                >
              </el-radio-group>
            </span>
          </div>
          <div class="item">
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981"
              @click="search"
              size="medium"
              >查询</el-button
            >
            <el-button
              type="primary"
              @click="exportExcel"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1320') : false
              "
              >导出</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="回访时间"
              prop="create_time"
            ></el-table-column>
            <el-table-column label="回访类型">
              <template slot-scope="scope">
                <span v-if="scope.row.return_type == 1">医生</span>
                <span v-if="scope.row.return_type == 2">患者</span>
                <span v-if="scope.row.return_type == 3">处方</span>
                <span v-if="scope.row.return_type == 4">咨询</span>
                <span v-if="scope.row.return_type == 5">其他</span>
              </template>
            </el-table-column>
            <el-table-column label="回访对象">
              <template slot-scope="scope">
                <span v-if="scope.row.return_object == 1">医生</span>
                <span v-if="scope.row.return_object == 2">患者</span>
                <span v-if="scope.row.return_object == 3">推荐人</span>
              </template>
            </el-table-column>
            <el-table-column label="回访来源">
              <template slot-scope="scope">
                <span v-if="scope.row.return_from == 1">主动</span>
                <span v-if="scope.row.return_from == 2">被动</span>
              </template>
            </el-table-column>
            <el-table-column label="回访方式" prop="visit_type">
            </el-table-column>
            <el-table-column label="回访信息">
              <template slot-scope="scope">
                <!-- 医生 -->
                <div v-if="scope.row.return_type == 1">
                  <div>
                    <span style="margin-right: 10px">{{
                      scope.row.doctor_name
                    }}</span>
                    <span v-if="scope.row.doctor_sex == 1">男</span>
                    <span v-if="scope.row.doctor_sex == 2">女</span>
                  </div>
                  <div>{{ scope.row.doctor_phone }}</div>
                </div>
                <!-- 患者 -->
                <div v-if="scope.row.return_type == 2">
                  <div>
                    <span style="margin-right: 10px">{{
                      scope.row.patient_name
                    }}</span>
                    <span v-if="scope.row.patient_sex == 1">男</span>
                    <span v-if="scope.row.patient_sex == 2">女</span>
                  </div>
                  <div>{{ scope.row.patient_age }}</div>
                </div>
                <!-- 处方 -->
                <div v-if="scope.row.return_type == 3">
                  <div>{{ scope.row.doctor_name }}</div>
                  <div>{{ scope.row.patient_name }}</div>
                  <div>{{ scope.row.pre_id }}</div>
                </div>
                <!-- 咨询 -->
                <div v-if="scope.row.return_type == 4">
                  <div>{{ scope.row.doctor_name }}</div>
                  <div>{{ scope.row.patient_name }}</div>
                  <div>{{ scope.row.consult_id }}</div>
                </div>
              </template>
            </el-table-column>

            <el-table-column label="处理问题类型" prop="solving_type">
            </el-table-column>
            <el-table-column label="回访原因" prop="desc"> </el-table-column>
            <el-table-column label="回访结果" prop="treatment_method">
            </el-table-column>
            <el-table-column label="标记为已回访类型" prop="is_return">
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 24px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      date: [],
      visit_id: "",
      return_type: 0,
      return_from: 0,
      solving_type: "",
      // is_on_return: '',
      treatment_method:'',
      visit_type: "",
      typeList: [],
      nameList: [],
      methodList: [],
      problemList: [],
      visit_info: {},
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getVisitName();
    this.getVisitMethod();
    this.getVisitProblem();
  },
  methods: {
    //获取回访人员
    getVisitName() {
      this.axios.post("platform/Clientreview/getVisitName").then((res) => {
        if (res.code == 0) {
          this.nameList = res.data;
          this.visit_id = Number(this.$route.query.visit_id);
          this.getList();
        }
      });
    },
    //获取回访方式
    getVisitMethod() {
      this.axios
        .post("platform/Admin/getVisitLabel", { label_name: "VISIT_METHOD" })
        .then((res) => {
          if (res.code == 0) {
            this.methodList = res.data;
          }
        });
    },
    //获取问题类型
    getVisitProblem() {
      this.axios
        .post("platform/Admin/getVisitLabel", { label_name: "PROBLEM_TPYE" })
        .then((res) => {
          if (res.code == 0) {
            this.problemList = res.data;
          }
        });
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        visit_id: this.visit_id,
        return_type: this.return_type,
        return_from: this.return_from,
        solving_type: this.solving_type,
        // is_on_return: this.is_on_return,
        treatment_method: this.treatment_method,
        visit_type: this.visit_type,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Clientreview/getVisitDetailList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              item.next_time = item.next_time
                ? dayjs.unix(item.next_time).format("YYYY-MM-DD")
                : "";
              return item;
            });
            this.visit_info = res.data.visit_info;
            this.totalNum = res.data.total;
          }
        });
    },
    //获取平台开方可以选择的剂型列表
    getDrugTypeList() {
      let platform_type = 3;
      this.axios
        .post("platform/photograph/getDrugTypeList", { platform_type })
        .then((res) => {
          this.options2 = res.data.list;
        });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    back() {
      history.back();
    },
    //导出
    exportExcel() {
      let data = {
        visit_id: this.visit_id,
        return_type: this.return_type,
        return_from: this.return_from,
        solving_type: this.solving_type,
        // is_on_return: this.is_on_return,
        treatment_method: this.treatment_method,
        visit_type: this.visit_type,
      };
      if (this.date && this.date.length > 0) {
        data.start_time = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.end_time = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/Clientreview/exportVisitDetailList", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 0px;
  .item {
    margin-right: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: center;
  }
  .inputclass {
    width: 160px;
  }
  .searchtitle {
    display: inline-block;
    width: 90px;
    text-align: right;
    box-sizing: border-box;
    margin-right: 8px;
  }
}
</style>
